import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import OverOns from './pages/OverOns';
import OnsModel from './pages/OnsModel';
import Diensten from './pages/Diensten';
import Contact from './pages/Contact';
import Offerte from './pages/Offerte';
import Voorwaarden from './pages/Voorwaarden';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/over-ons" element={<OverOns />} />
          <Route path="/ons-model" element={<OnsModel />} />
          <Route path="/diensten" element={<Diensten />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/offerte" element={<Offerte />} />
          <Route path="/voorwaarden" element={<Voorwaarden />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
